<template>
  <footer id="explore" class="text-white footer">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-lg-7">
          <p class="footer-sub-headline">Buy a kit or upload to get started</p>
          <h2>Unlock your own story with Living DNA</h2>
          <p>
            Embark on a transformative journey with our advanced DNA test—reveal your ancestry, connect with
            relatives, and gain insights into your health and heritage. Uncover the stories hidden in your
            genes today!
          </p>
          <div class="d-flex align-items-center gap-4">
            <a href="https://livingnda.com" class="btn btn-light btn-sm">Buy a kit</a>
            <router-link :to="{ name: 'who-does-this-dna-belong-to' }" class="flex align-items-center footer-btn-link">
              <span>Upload</span>
              <i class="fa-solid fa-arrow-right ms-3"></i>
            </router-link>
          </div>
        </div>
        <div class="col-12">
          <ul class="list-unstyled footer-grid">
            <li class="d-flex">
              <i class="fas fa-dna footer-icon footer-icon-first me-3"></i>
              <div>
                <p><strong>Get the most detailed British breakdown</strong> Explore your roots with our DNA
                  test – unlocking your genetic journey, simply and accurately.</p>
              </div>
            </li>
            <li class="d-flex">
              <i class="fa-solid fa-mars-and-venus footer-icon footer-icon-second me-3"></i>
              <div>
                <p><strong>Discover your motherline and fatherline.</strong> Reveal the hidden chapters of
                  your family history through exploration of your maternal and paternal lines.</p>
              </div>
            </li>
            <li class="d-flex">
              <i class="fa-solid fa-arrow-up-from-bracket footer-icon footer-icon-third me-3"></i>
              <div>
                <p><strong>Upload if you've already tested with another provider.</strong> Bring your
                  existing test results into focus by uploading data from other providers effortlessly.</p>
              </div>
            </li>
            <li class="d-flex">
              <i class="fa-solid fa-user-group footer-icon footer-icon-fourth me-3"></i>
              <div>
                <p><strong>Discover new relatives with Family Matching.</strong> Connect with unknown
                  relatives through our advanced Family Matching feature, unlocking a world of newfound
                  connections.</p>
              </div>
            </li>
            <li class="d-flex">
              <i class="fa-regular fa-heart footer-icon footer-icon-fifth me-3"></i>
              <div>
                <p><strong>Get health and wellbeing insights.</strong> Unlock personalized health and
                  wellness insights, tailored just for you, with our comprehensive analysis."</p>
              </div>
            </li>
            <li class="d-flex">
              <i class="fa-solid fa-rocket footer-icon footer-icon-sixth me-3"></i>
              <div>
                <p><strong>Discover your Viking and Neanderthal past.</strong> Embark on a journey into your
                  ancestral past, unveiling Viking and Neanderthal connections through our DNA analysis.</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
</script>

<style lang="scss" scoped>
.footer {
  background: #1a3a77;
  padding: 80px 40px;

  p {
    font-weight: 300;
  }

  .btn {
    padding: 8px 18px;
  }

  .footer-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 32px 64px;
    margin-top: 64px;

    @media(min-width:768px) {
      grid-template-columns: repeat(2, 1fr);
    }

    p,
    li {
      margin: 0;
      font-weight: 300;
    }

    li {
      font-size: 14px;

      .footer-icon {
        font-size: 18px;
        color: #93c5fd;

        &-second,
        &-third,
        &-fifth,
        &-sixth {
          font-size: 22px;
        }
      }
    }

    .fa-small {
      font-size: 1.5rem;
    }

    strong {
      font-size: 16px;
    }

  }

  .footer-sub-headline {
    color: #93c5fd;
  }

  .footer-btn-link {
    color: #fff;
    text-decoration: none;
  }
}
</style>